import { escape } from '@academica-box/utils/scripts/directives/escape'
import type { Plugin } from 'nuxt/app'

export default defineNuxtPlugin(escape as Plugin)
